import { RefProperty } from '../../ref-property.model';
import { CollectionValuePresenterModel } from './collection-value-presenter-model';

export class UserStateExcludingUserFirstLoginPresenterModel {
  dateFormat?: CollectionValuePresenterModel;
  dateTimeFormat?: CollectionValuePresenterModel;
  fontSize?: number;
  language?: RefProperty;
  layoutMode?: string;
  menuMode?: string;
  theme?: RefProperty;
  timeFormat?: CollectionValuePresenterModel;
  timeZone?: RefProperty;
}
